<template>
  <div>
    <div class="container">
      <div class="banner">
        <img style="width: 100%; vertical-align: top" src="../../assets/images/aboutUs/icon_02.png"/>
      </div>
      <div class="tab flex">
        <div @click="tabSwitch(item,index)" class="tab-item" :class="activeIndex==index?'tab-item-select':''" v-for="(item,index) in tabList" :key="index">{{item.name}}</div>
      </div>
      <div class="title-box">
        <div class="title">{{title}}</div>
        <div class="title-border"></div>
      </div>
      <div class="list pc_container">
        <div v-for="(item,index) in list" :key="index">
          <div class="list-item flex" style="justify-content: space-between" v-if="index%2===0">
            <div class="list-item-content">
              <div class="list-item-name">{{item.title}}</div>
              <div class="list-item-text">{{item.position}}</div>
              <div class="list-item-line"></div>
              <div class="list-item-text">{{item.excerpt}}</div>
            </div>
            <img class="list-item-pic" :src="item.cover[0]"/>
          </div>
          <div class="list-item flex" v-if="index%2===1">
            <img class="list-item-pic" :src="item.cover[0]"/>
            <div class="list-item-content" style="margin-left: 50px">
              <div class="list-item-name">{{item.title}}</div>
              <div class="list-item-text">{{item.position}}</div>
              <div class="list-item-line"></div>
              <div class="list-item-text">{{item.excerpt}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex" style="justify-content: center;margin-top: 130px;padding-bottom: 105px">
        <el-pagination
              @current-change="change"
              background
              layout="prev, pager, next"
              :total="total">
            </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 1,
      tabList:[],
      query:{
        page:1,
        limit:10,
        slug:null,
      },
      list:[],
      total:0,
      title:'',
    };
  },
  watch:{
    $route:{
      handler(value){
        if(value.path === '/company/leader'){
          this.getType().then(res=>{
            this.tabList = res.data;
            if(value.query.type){
              for(let i=0;i<this.tabList.length;i++){
                if(value.query.type == this.tabList[i].slug){
                  this.activeIndex = i;
                  break
                }
              }
              this.query.slug = value.query.type;
              this.title =  this.tabList[this.activeIndex].name;
              this.getList();
            }else {
              this.title =  this.tabList[this.activeIndex].name;
              this.query.slug = this.tabList[this.activeIndex].slug;
              this.getList();
            }
          })
        }
      },
      deep:true,
      immediate:true
    },
  },
  created() {

  },
  methods: {
    // 获取分类
    getType(){
      return this.$request({
        url: `submenu/general`,
        method: 'get',
      })
    },
    // 切换
    tabSwitch(item) {
      this.$router.push({
        path:item.href,
      })
    },
    // 跳转详情
    detail(item){
      this.$router.push({
        path:'/news/detail',
        query:{
          id:item.id
        },
      })
    },
    // 列表
    getList(){
      this.$request({
        url: `leader`,
        method: 'get',
        params:this.query,
      }).then(res=>{
        this.total = res.total;
        this.list = res.data;
      })
    },
    // 页面切换
    change(e){
      this.query.page = e;
      window.scrollTo(0, 0);
      this.getList();
    },
  }
}
</script>

<style scoped lang="scss">
.container{
  width: 100%;
  .banner{
    width: 100%;
    object-fit: cover;
    display: block;
    box-sizing: border-box;
  }
  .tab{
    width: 100%;
    padding: 0 30vw;
    height: 70px;
    background: #ffffff;
    display: flex;
    font-size: 16px;
    color: #333333;
    justify-content: space-between;
    margin-top: -10px;
    .tab-item{
      height: 70px;
      line-height: 70px;
      cursor: pointer;
    }
    .tab-item-select{
     border-bottom: solid 2px #2A59AB;
    }
  }
  .title-box{
    width: 100%;
    margin-top: 90px;
    .title{
      width: 100%;
      text-align: center;
      font-size: 36px;
      color: #333333;
    }
    .title-border{
      width: 115px;
      height: 4px;
      background: #2A59AB;
      margin: auto;
    }
  }
  .list{
    margin-top: 52px;
    .list-item{
      padding: 24px 30px 25px 30px;
      box-sizing: border-box;
      height: 379px;
      background: #C9D8EE;
      border-radius: 0px;
      margin-bottom: 52px;
      .list-item-content{
        .list-item-name{
          font-weight: 500;
          font-size: 24px;
          color: #333333;
        }
        .list-item-line{
          margin-top: 20px;
          width: 78px;
          height: 1px;
          background: #333333;
        }
        .list-item-text{
          margin-top: 17px;
          font-weight: 500;
          font-size: 16px;
          color: #666666;
        }
      }
      .list-item-pic{
        width: 249px;
        height: 330px;
        object-fit: cover;
      }
    }
  }
}
</style>
